import { Paper, Stack, Typography, type SxProps } from "@mui/material";
import type { FC, ReactNode } from "react";

export interface ScheduleButtonProps {
  onClick: () => void;
  selected: boolean;
  title: string;
  icon: ReactNode;
  disabled?: boolean;
  subtitle?: string;
  sx?: SxProps;
}

export const ScheduleButton: FC<ScheduleButtonProps> = ({
  onClick,
  selected,
  title,
  icon,
  disabled,
  subtitle,
  sx = [],
}) => {
  return (
    <Paper
      variant="outlined"
      sx={{
        borderColor: selected ? "primary.main" : null,
        borderWidth: selected ? 3 : null,
        opacity: disabled ? 0.5 : null,
        "&:hover": {
          cursor: disabled ? null : "pointer",
          opacity: disabled ? null : 0.75,
        },
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        p: 2,
        ...sx,
      }}
      data-testid="schedule-immediate-button"
      data-selected={selected}
      onClick={() => !disabled && onClick && onClick()}
    >
      <Stack
        direction="row"
        spacing={1}
        alignItems="center"
        width="100%"
        justifyContent="flex-start"
      >
        {icon}
        <Stack direction="column" spacing={0}>
          <Typography variant="body1" fontWeight="bold">
            {title}
          </Typography>
          {subtitle && (
            <Typography variant="body2" color="textSecondary">
              {subtitle}
            </Typography>
          )}
        </Stack>
      </Stack>
    </Paper>
  );
};
